<div class="modal-body" id="modal-body">
  <ng-container *ngIf="contentType === 'detail'; else listBlock">
    <app-equipment-constructors-detail [pk]="pk" [defaults]="defaults" (detailSaved)="modal.close($event)">
    </app-equipment-constructors-detail>
  </ng-container>
  <ng-template #listBlock>
    <app-equipment-constructors-list (rowClick)="modal.close($event)" [disableUrlUpdate]="true"
                                     [disabledButtons]="localDisabledButtons" [disabledColumns]="disabledColumns"
                                     [filters]="filters" [disableRouterLink]="true">
    </app-equipment-constructors-list>
  </ng-template>
</div>